var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-progress-linear',_vm._b({attrs:{"indeterminate":"","height":_vm.calcSize,"color":"primary"}},'v-progress-linear',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }